const carousel = () => {
    const carouselItems = document.querySelectorAll('.carousel')
    if(carouselItems.length) {
        // Default image
        const firstImg = document.querySelector('.carousel')
        const defaultImgSrc = firstImg.dataset.filename
        const defaultImgAlt = firstImg.dataset.alt
        const imgSlot = document.querySelector('.screenshot-slot img')
        // Initialize carousel hover
        carouselItems.forEach(item => {
            item.addEventListener('mouseenter', e => {
                item.classList.add('hover')
                if(item !== firstImg) firstImg.classList.remove('hover')
                imgSlot.setAttribute('src', item.dataset.filename)
                imgSlot.setAttribute('alt', item.dataset.alt)
            })
            item.addEventListener('mouseleave', e => {
                item.classList.remove('hover')
                firstImg.classList.add('hover')
                imgSlot.setAttribute('src', defaultImgSrc)
                imgSlot.setAttribute('alt', defaultImgAlt)
            })
        })
    }
};

export default carousel;
